const getters = {
  appid: (state) => state.appid,
  loading: (state) => state.loading,
  posts: (state) => state.posts,
  drafts: (state) => state.drafts,
  campaigns: (state) => state.campaigns,
  status: (state) => state.status,
  campaignId: (state) => state.campaignId,
  draftId: (state) => state.draftId,
  eventtasks: (state) => state.eventtasks,
  cost: (state) => state.cost,
  task: (state) => state.task,
  assignee: (state) => state.assignee,
  kpis: (state) => state.kpis,
  marketingPlan: (state) => state.marketingPlan,
  marketingTemplate: (state) => state.marketingTemplate,
};

export default getters;
